import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import AuthLayout, { Field, SubmitBtn } from "./AuthLayout";

function formatError(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || String(e)).join(" ");
  return String(detail);
}

export default function ResetPassword() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const email = sp.get("email") || "";
  const code = sp.get("code") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (form.password !== form.confirm) return setErr("Passwords don't match.");
    if (form.password.length < 8) return setErr("Password must be at least 8 characters.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { email, code, new_password: form.password });
      toast.success("Password reset. You're signed in.");
      nav("/app/dashboard");
    } catch (e) {
      setErr(formatError(e?.response?.data?.detail || e.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Set a new password"
      subtitle={`For ${email || "your account"}.`}
      footer={
        <>
          Back to{" "}
          <Link to="/login" className="font-semibold text-lm-primary hover:text-lm-primaryHover underline underline-offset-4">
            sign in
          </Link>
        </>
      }
    >
      <form onSubmit={submit} data-testid="reset-form">
        <Field label="New password" id="new-password" name="password" type="password" required autoComplete="new-password"
          placeholder="At least 8 characters" hint="8+ chars"
          value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
          data-testid="reset-password" />
        <Field label="Confirm password" id="confirm-password" name="confirm" type="password" required autoComplete="new-password"
          placeholder="Re-enter new password"
          value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
          data-testid="reset-confirm" />
        {err && <div className="mb-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{err}</div>}
        <SubmitBtn loading={busy} data-testid="reset-submit">Update password & sign in</SubmitBtn>
      </form>
    </AuthLayout>
  );
}
